var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_google logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.0009 8.18411C16.0009 7.64031 15.9559 7.09357 15.86 6.55859H8.16211V9.63914H12.5703C12.3874 10.6327 11.7996 11.5116 10.939 12.0701V14.0689H13.5689C15.1133 12.6756 16.0009 10.618 16.0009 8.18411Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M8.16022 16C10.3613 16 12.2176 15.2916 13.57 14.0688L10.9401 12.07C10.2084 12.5579 9.26378 12.8342 8.16322 12.8342C6.03409 12.8342 4.22882 11.4262 3.58108 9.5332H0.867188V11.5938C2.25262 14.2951 5.07448 16 8.16022 16Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M3.57905 9.53363C3.23719 8.54009 3.23719 7.46425 3.57905 6.47072V4.41016H0.868147C-0.289382 6.6706 -0.289382 9.33375 0.868147 11.5942L3.57905 9.53363Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M8.16022 3.16633C9.32375 3.1487 10.4483 3.57786 11.291 4.36563L13.621 2.08167C12.1456 0.723645 10.1874 -0.0229766 8.16022 0.000539093C5.07448 0.000539093 2.25262 1.70542 0.867188 4.40972L3.57809 6.47028C4.22282 4.57433 6.03109 3.16633 8.16022 3.16633Z",
    fill: "#FE2C25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.c2bf7608d57da287ee588d0a073b8d21.svg";
export { ForwardRef as ReactComponent };